import React from 'react';
import {Select} from './Select';
import {FieldProp} from '../../types';
import {range} from '../../_helpers/array';

type RangeSelectProps = FieldProp & {};

export const RangeSelect: React.FunctionComponent<RangeSelectProps> = (props): JSX.Element => {
    const field = props.field;
    field.choices = range(
        Number.parseInt(field.flowCustomDisplayComponentConfig.min, 10),
        Number.parseInt(field.flowCustomDisplayComponentConfig.max, 10)
    ).map((n: number) => ({
        text: n,
        value: n,
        label: n
    }));
    return (
        <Select {...props} field={field}/>
    );
};